import {
  getHoverColor,
  getGradientBackground,
  hex2rgb,
  hex2hsl,
} from 'vuestic-ui/src/services/color-functions'
import { originalTheme } from '../themes-config'

const ColorThemeMixin = {
  data () {
    return {
      colorThemeDefault: 'primary',
      colorDefault: '#000000',
    }
  },
  props: {
    color: {
      type: String,
    },
  },
  computed: {
    // This allows a multitude of defaults.
    // theme color => color => theme default => hard default
    colorComputed () {
      if (this.$themes && this.$themes[this.color]) {
        return this.$themes[this.color]
      }
      if (this.color) {
        return this.color
      }
      if (this.$themes && this.$themes[this.colorThemeDefault]) {
        return this.$themes[this.colorThemeDefault]
      }
      return this.colorDefault
    },
  },
}

const ColorThemeActionsMixin = {
  methods: {
    // Pass colors to change global theme.
    setColors (colors) {
      Object.keys(colors).forEach(key => {
        this.$themes[key] = colors[key]
        document.documentElement.style.setProperty(`--va-${key}`, colors[key])
      })
    },
  },
}

const ColorThemePlugin = {
  install (Vue, options) {
    Vue.prototype.$themes = Object.assign({}, originalTheme.colors, options)
    Vue.observable(Vue.prototype.$themes)
    for (const key in options) {
      document.documentElement.style.setProperty(`--va-${key}`, options[key])
    }
  },
}

const colorShiftHsl = (main, offset = { h: 0, s: 0, l: 0 }) => {
  offset = {
    h: offset.h || 0,
    s: offset.s || 0,
    l: offset.l || 0,
  }

  const color = hex2hsl(main)

  const normalizeParam = (value, params = { start: 0, end: 100 }) =>
    value < params.start
      ? params.start
      : value > params.end
        ? params.end
        : value

  color.h = normalizeParam(color.h + offset.h, { end: 360 })
  color.s = normalizeParam(color.s + offset.s)
  color.l = normalizeParam(color.l + offset.l)

  return color
}

export {
  ColorThemePlugin,
  ColorThemeMixin,
  ColorThemeActionsMixin,
  getHoverColor,
  getGradientBackground,
  hex2rgb,
  hex2hsl,
  colorShiftHsl,
}
